import { render } from "./u-group.vue?vue&type=template&id=2aa62302"
import script from "./u-group.vue?vue&type=script&lang=js"
export * from "./u-group.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__